import { withAnalytics } from 'components/common/analytics';
import { Swap } from 'components/sign-up/components/phone-number/imei/swap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { IApplicationState } from 'models';

const mapStateToProps = ({
    device
}: IApplicationState) => ({
    compatibility: device.compatibility.compatibility
});

const enhance = compose(
    withAnalytics,
    connect(mapStateToProps, null),
);

const SwapContainer = enhance(Swap);

export { SwapContainer };
